// extracted by mini-css-extract-plugin
export default {"container":"IssueTypeToken-module__container--bGRt0","tokenText":"IssueTypeToken-module__tokenText--fyjvE","token":"IssueTypeToken-module__token--iQHKj"};